export const trendingStocksTrackAnalytics = {
  componentNameCarousel: "stocks_market_card_sku_details",
  componentNamePlp: "trending_stocks_plp",
  referenceId: "trending_stocks",
  referenceIdLinkClick: "trending_stock",
  entryPoints: {
    carousel: "horizontal/entrypoint",
    plp: "plp/entrypoint",
  },
  propertyType: "plp",
  productName: "trending-stocks",
  campaign: "DPAOP3| Mar",
  sprint: "DPAOP4| Apr",
  productCategory: "trading-mall" as const,
  clickTypes: {
    viewAll: "stocks_market_card_sku_details_link_click",
    infoBannerLink: "stocks_market_card_sku_details_link_click",
    tabClick: "stocks_market_card_sku_details_tab_click",
    cardClick: "stocks_market_card_sku_details_card_click",
    buttonClick: "stocks_market_card_sku_details_button_click",
    expand: "trending_stocks_carousel_expand_icon_click",
    showMore: "trending_stocks_plp_show_more_click",
  },
} as const;
